export default [
  {
    path: '/dashboard/myDashboard',
    name: 'dashboard',
    component: () => import('@/views/dashboard/myDashboard/index.vue'),
  },
]
